import { render, staticRenderFns } from "./CertificateStatusIcon.vue?vue&type=template&id=06e9e962&scoped=true&"
import script from "./CertificateStatusIcon.vue?vue&type=script&lang=ts&"
export * from "./CertificateStatusIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateStatusIcon.vue?vue&type=style&index=0&id=06e9e962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e9e962",
  null
  
)

export default component.exports